import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SparkForecastDto } from '@/app/common/general-types/spark-ads-v3.dto';
import { formatShortNumber } from '../../../../spark-ads.format';

/**
 * TikTok's audience estimate for the current targeting.
 *
 * When TikTok cannot produce an estimate this says so. It deliberately does not fall
 * back to arithmetic — an invented reach figure is worse than no figure, because the
 * user would budget against it.
 */
@Component({
  selector: 'sa-estimate-banner',
  imports: [],
  templateUrl: './estimate-banner.html',
  styleUrl: './estimate-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstimateBanner {
  readonly forecast = input<SparkForecastDto | undefined>(undefined);

  protected readonly isAvailable = computed(() => this.forecast()?.available === true);

  protected readonly audienceRange = computed(() => {
    const forecast = this.forecast();
    if (!forecast?.available) {
      return '—';
    }

    const lower = forecast.audienceSizeLower ?? 0;
    const upper = forecast.audienceSizeUpper ?? lower;

    if (upper > lower) {
      return `${formatShortNumber(lower)} – ${formatShortNumber(upper)}`;
    }
    return formatShortNumber(lower);
  });

  protected readonly unavailableReason = computed(
    () =>
      this.forecast()?.unavailableReason ??
      'TikTok has not returned an audience estimate for this targeting yet.',
  );
}
